import baustein from "baustein";
import template from "templates/modules/search_summary_bar.jinja";

import "web/script/components/accordion-container";
import "web/script/components/hide-on-click";
import "web/script/components/saved-search-button";
import "web/script/components/saved-search-signup-prompt";
import "web/script/components/tracked-link";

/**
 *
 */
export default baustein.register("search-summary-bar", {
    template: template,
});
